export const SHOP_SURFACE_ALL = 'all';

/** Prefix shared by every taxonomy route served by this web app (`pages/shop/[[...slug]]`). */
export const SHOP_ROUTE_PREFIX = '/shop/';

export const SHOP_VALID_SURFACES: readonly string[] = [SHOP_SURFACE_ALL];

export const SHOP_TAXONOMY_ALIASES = ['dept', 'cat', 'subcat', 'ptype'];
